export default __webpack_public_path__ + "/dist/images/glass-icon.e503f768f16fa36b58fdf08b81aab358.svg";